import React from 'react';

interface CompanyLogoProps {
  company: string;
  className?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({ company, className = "w-8 h-8" }) => {
  const getLogo = () => {
    switch (company) {
      case 'Meta':
        return (
          <img 
            src="https://pngimg.com/d/meta_PNG5.png" 
            alt="Meta Logo" 
            className={`${className} object-contain`}
          />
        );
      case 'C3 AI':
        return (
          <img 
            src="https://companieslogo.com/img/orig/AI-ca024369.png?t=1720244490&download=true" 
            alt="C3 AI Logo" 
            className={`${className} object-contain`}
          />
        );
      case 'Imply':
        return (
          <img 
            src="https://www.freelogovectors.net/wp-content/uploads/2022/03/imply-logo_freelogovectors.net_.png" 
            alt="Imply Logo" 
            className={`${className} object-contain`}
          />
        );
      case 'PromptQL':
        return (
          <div className={`${className} bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg flex items-center justify-center`}>
            <span className="text-white text-xs font-bold">PQ</span>
          </div>
        );
      case 'MIT':
        return (
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/MIT_logo.svg/1024px-MIT_logo.svg.png" 
            alt="MIT Logo" 
            className={`${className} object-contain`}
          />
        );
      default:
        return (
          <div className={`${className} bg-gray-200 rounded flex items-center justify-center`}>
            <span className="text-gray-600 text-xs font-medium">{company.charAt(0)}</span>
          </div>
        );
    }
  };

  return (
    <div className="flex items-center justify-center">
      {getLogo()}
    </div>
  );
};

export default CompanyLogo;
